import React from 'react';
import {
  IMessageCreatedSubscriptionFields,
  IMessageCreatedSubscriptionResponseFields,
  useMessageCreatedSubscription,
} from '../../../../graphql/subscription/message/messageCreatedSubscription';

interface IProps {
  chatroomFragment: string;
  variables: IMessageCreatedSubscriptionFields;
  onSubscriptionData: (data: IMessageCreatedSubscriptionResponseFields) => void;
}

export default function HeaderNotificationMessageCreatedSubscription(
  props: IProps
) {
  const { chatroomFragment, variables, onSubscriptionData } = props;
  useMessageCreatedSubscription(
    `
      chatroom {
        ${chatroomFragment}
      }
      `,
    {
      variables,
      onSubscriptionData: ({ subscriptionData }) => {
        if (
          subscriptionData &&
          subscriptionData.data &&
          subscriptionData.data.messageCreated
        ) {
          onSubscriptionData(subscriptionData.data.messageCreated);
        }
      },
    }
  );

  return null;
}
